/* eslint-disable @typescript-eslint/no-use-before-define */
import {
    Action,
    ActionReducerMap,
    createFeatureSelector,
    createSelector,
    StoreModule,
} from '@ngrx/store';

import { Dealer } from '@polaris-customerweb/sharedcomponents.map';
import { DealerAction, SetActiveDealer, SetDealers } from './dealer.actions';

export interface DealerState {
    activeDealer: Dealer | undefined;
    dealers: Dealer[];
}

const reducerMap: ActionReducerMap<DealerState> = {
    activeDealer: activeDealerReducer,
    dealers: dealersReducer,
};

export const selectDealerState = createFeatureSelector<DealerState>('dealer');
export const selectActiveDealer = createSelector(
    selectDealerState,
    (state) => state.activeDealer
);
export const selectDealers = createSelector(
    selectDealerState,
    (state) => state.dealers
);

export const dealerStoreModule = StoreModule.forFeature('dealer', reducerMap);

function activeDealerReducer(state: Dealer, action: Action) {
    switch (action.type) {
        case DealerAction.setActiveDealer:
            return (action as SetActiveDealer).dealer;
        default:
            return state;
    }
}

function dealersReducer(state = [], action: Action) {
    switch (action.type) {
        case DealerAction.setDealers:
            return (action as SetDealers).dealers;
        default:
            return state;
    }
}
